import {
  mapValues,
  omitBy,
  isArray,
  map,
  filter,
  isPlainObject,
  isString,
} from "lodash";

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};

export function omitDeepBy<T extends object>(
  object: T,
  testingFunction: (val: any) => boolean
): DeepPartial<T> {
  const mapped = mapValues(object, (value) => {
    if (isPlainObject(value) && !isString(value)) {
      const omitted = omitBy<{}>(value, testingFunction);
      return omitDeepBy(omitted, testingFunction);
    } else if (isArray(value)) {
      const omitted = map(value, (v) => {
        if (isPlainObject(v) && !isString(v)) {
          return omitDeepBy(v, testingFunction);
        }
        return v;
      });
      return filter(omitted, (v) => !testingFunction(v));
    } else {
      return testingFunction(value) ? null : value;
    }
  });

  // @ts-ignore
  return omitBy(mapped, testingFunction);
}
